import { jsx as r } from "react/jsx-runtime";
const h = ({
  size: o = 24,
  color: e = "currentColor",
  titleAccess: t,
  ...n
}) => /* @__PURE__ */ r(
  "svg",
  {
    width: o,
    height: o,
    ...n,
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-label": t,
    children: /* @__PURE__ */ r(
      "path",
      {
        d: "M15.1 18L9.09998 12L15.1 6",
        stroke: e,
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
);
export {
  h as ChevronLeftIcon
};
